import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isString as _isString, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import {
  VFButton,
  VFText,
  PercentageIndicator,
  Icon,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeColors } from '../../../Themes';

import styles from './MyPlanItem.Styles';

const MyPlanItem = ({
  theme,
  icon,
  iconSize,
  percentageIndicatorFillColor,
  percentageIndicatorSecondaryColor,
  percentageIndicatorContainerStyle,
  percentageIndicatorShouldAnimate,
  leftTextStyle,
  rightTextStyle,
  percentageValue,
  percentageTextStyle,
  rightText,
  RightComponent,
  leftText,
  LeftComponent,
  addUsageButtonTitle,
  onAddUsageButtonPress,
  renderButtons,
  addUsageButtonType,
  addUsageButtonTextStyle,
  images,
  withPercentageText,
  containerStyle,
  withIconBackground,
  rightTextPlaceHolders,
  rightTextContainerStyle,
}) => {
  const hasPercentageValue = percentageValue !== undefined;
  const frameworkColors = getThemeColors(theme.name);

  const renderLeftText = (() => {
    if (leftText || LeftComponent) {
      return (
        LeftComponent ?? <VFText style={[styles.leftTextStyle, leftTextStyle]} i18nKey={leftText} />
      );
    }
  })();

  const renderRightText = (() => {
    if (rightText || RightComponent || withPercentageText) {
      return (
        <View style={styles.rightTextContainerStyle}>
          {rightText ? (
            <VFText
              style={[styles.rightTextStyle(frameworkColors), rightTextStyle]}
              i18nKey={rightText}
              placeHolders={rightTextPlaceHolders}
            />
          ) : (
            RightComponent
          )}

          {withPercentageText && hasPercentageValue && (
            <VFText
              style={[styles.percentageTextStyle(theme), percentageTextStyle]}
              i18nKey={'(' + percentageValue + '%)'}
            />
          )}
        </View>
      );
    }
  })();

  const renderPercentageIndicator = () => {
    return (
      hasPercentageValue && (
        <PercentageIndicator
          value={percentageValue}
          isAnimated={percentageIndicatorShouldAnimate}
          animate={percentageIndicatorShouldAnimate}
          fillColor={
            (_isString(percentageIndicatorFillColor) && percentageIndicatorFillColor) ||
            theme.colors.fillColor
          }
          color={
            (_isString(percentageIndicatorSecondaryColor) && percentageIndicatorSecondaryColor) ||
            theme.colors.secondryColor
          }
          containerStyle={[
            styles.percentageIndicatorContainerStyle,
            percentageIndicatorContainerStyle,
          ]}
        />
      )
    );
  };

  const renderButton = hasOnAddUsageButtonPress => {
    return (
      _isFunction(hasOnAddUsageButtonPress) && (
        <VFButton
          type={addUsageButtonType}
          style={styles.addUsageButtonStyle}
          title={addUsageButtonTitle}
          textStyle={[styles.addUsageButtonTextStyle, addUsageButtonTextStyle]}
          onPress={onAddUsageButtonPress}
        />
      )
    );
  };

  const renderIcon = () => {
    return (
      !!icon && (
        <View
          style={[
            styles.iconContainerStyle,
            withIconBackground && styles.iconContainerBgStyle(frameworkColors),
          ]}
        >
          <Icon name={images[icon]} type="image" size={iconSize > 30 ? 30 : iconSize} />
        </View>
      )
    );
  };

  return (
    <View style={[styles.containerStyle, containerStyle]}>
      {renderIcon()}

      <View style={styles.usageDataViewStyle}>
        <View
          style={[
            styles.dataPercentageContainerStyle(percentageValue, icon),
            rightTextContainerStyle,
          ]}
        >
          {(Boolean(renderRightText) || Boolean(renderLeftText)) && (
            <View style={styles.usageValuesContainerViewStyle}>
              <View style={styles.headerTextContainerStyle(leftText)}>
                {renderLeftText}
                {renderRightText}
              </View>
            </View>
          )}
          {renderPercentageIndicator()}
        </View>

        {_isFunction(renderButtons) ? renderButtons() : renderButton(onAddUsageButtonPress)}
      </View>
    </View>
  );
};

MyPlanItem.defaultProps = {
  theme: LightThemeColors,
  iconSize: 20,
  percentageIndicatorShouldAnimate: false,
  shouldShowBackGround: false,
  addUsageButtonType: 'secondary',
  withPercentageText: false,
};

MyPlanItem.propTypes = {
  icon: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
  images: PropTypes.object,
  percentageIndicatorFillColor: PropTypes.string,
  percentageIndicatorSecondaryColor: PropTypes.string,
  percentageIndicatorContainerStyle: ViewPropTypes.style,
  rightTextContainerStyle: ViewPropTypes.style,
  percentageIndicatorShouldAnimate: PropTypes.bool,
  rightText: PropTypes.string,
  RightComponent: PropTypes.element,
  leftText: PropTypes.string,
  LeftComponent: PropTypes.element,
  leftTextStyle: TextPropTypes.style,
  rightTextStyle: TextPropTypes.style,
  percentageValue: PropTypes.number,
  percentageTextStyle: TextPropTypes.style,
  shouldShowBackGround: PropTypes.bool,
  addUsageButtonTitle: PropTypes.string,
  rightTextPlaceHolders: PropTypes.arrayOf(PropTypes.any),
  onAddUsageButtonPress: PropTypes.func,
  renderButtons: PropTypes.func,
  addUsageButtonType: PropTypes.string,
  addUsageButtonTextStyle: TextPropTypes.style,
  containerStyle: ViewPropTypes.style,
  withIconBackground: PropTypes.bool,
  withPercentageText: PropTypes.bool,
  theme: PropTypes.object,
};
export default withTheme(MyPlanItem);
